import React from "react";
import { Typography, Container, Paper, Box } from "@mui/material";

export default function ReportsPage() {
  return (
    <Container maxWidth="lg">
      <Paper sx={{ padding: 4, marginTop: 4 }}>
        <Typography variant="h4" gutterBottom>Reports</Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Institutional-grade downloadable reports with top companies by metric
        </Typography>
        <Box>
          <Typography variant="subtitle1" color="text.secondary">
            [Demo charts or tables would appear here based on GCS long-format financial data.]
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}